import type { PermitIndexID, TaskGenerator } from '../../compliance-shared/types/compliance.ts';
import type { Facility } from '../../compliance-shared/types/common.ts';
import router from '@/router';
import { tenantID } from '@/router/route-constants';

export function permitIndexingBuildUrl({
  permitIndexID,
  facilityID,
  taskGeneratorID,
}: {
  permitIndexID: PermitIndexID;
  facilityID: Facility['facilityID'];
  taskGeneratorID: TaskGenerator['taskGeneratorID'] | undefined | null;
}): string {
  return (
    window.location.origin.replace('https://compliance', 'https://permits') +
    router.resolve({
      name: 'Permit Indexing Editor',
      params: {
        tenantID,
        permitIndexID,
      },
      query: {
        facilities: facilityID,
        taskGeneratorID,
      },
    }).fullPath
  );
}
